module.exports = __webpack_public_path__ + "assets/img/qingshoufang.f36bdde5.png";